import { render, staticRenderFns } from "./singleList.vue?vue&type=template&id=c710f81a&scoped=true"
import script from "./singleList.vue?vue&type=script&lang=js"
export * from "./singleList.vue?vue&type=script&lang=js"
import style0 from "./singleList.vue?vue&type=style&index=0&id=c710f81a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c710f81a",
  null
  
)

export default component.exports